import React from 'react';
import { classNames } from 'primereact/utils';

const getFixedGridStyle = (gridLayout, gridRows) => {
  if (gridLayout === '3x2') {
    return { gridTemplateRows: 'repeat(2, minmax(0, 1fr))' };
  }
  if ((gridLayout === '2x4' || gridLayout === '2x2') && gridRows) {
    return { gridTemplateRows: `repeat(${gridRows}, minmax(0, 1fr))` };
  }
  return undefined;
};

/** 위치별 사진 그룹 — 그리드 레이아웃 */
const WheelReportPhotoPositionGroup = ({
  title,
  showHeader = true,
  slots = [],
  columns = 2,
  gridLayout = '2col',
  gridRows,
  emptyMessage = '등록된 사진 없음',
}) => {
  const gridStyle = getFixedGridStyle(gridLayout, gridRows);

  return (
    <div className="wheel-report-photo-group">
      {showHeader && title && (
        <div className="wheel-report-photo-group-header">{title}</div>
      )}
      <div
        className={classNames('wheel-report-photo-grid', {
          'wheel-report-photo-grid--1col': gridLayout === '1col',
          'wheel-report-photo-grid--1col-compact': gridLayout === '1col-compact',
          'wheel-report-photo-grid--2col': gridLayout === '2col',
          'wheel-report-photo-grid--2col-compact': gridLayout === '2col-compact',
          'wheel-report-photo-grid--3col': gridLayout === '3col',
          'wheel-report-photo-grid--3col-compact': gridLayout === '3col-compact',
          'wheel-report-photo-grid--3x2': gridLayout === '3x2',
          'wheel-report-photo-grid--2x4': gridLayout === '2x4',
          'wheel-report-photo-grid--2x2': gridLayout === '2x2',
          'wheel-report-photo-grid--fixed-cells': Boolean(gridStyle),
        })}
        style={gridStyle}
      >
        {slots.map((slot) => (
          <div
            key={slot.partCode}
            className={classNames('wheel-report-photo-item', {
              'wheel-report-photo-item--placeholder': slot.isPlaceholder,
            })}
          >
            {slot.label ? (
              <div className="wheel-report-photo-title">{slot.label}</div>
            ) : null}
            <div className="wheel-report-photo-frame">
              {slot.src ? (
                <img
                  src={slot.src}
                  alt={slot.label || '사진'}
                  crossOrigin="anonymous"
                />
              ) : (
                <span className="wheel-report-photo-empty">
                  {slot.isPlaceholder ? '' : emptyMessage}
                </span>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default WheelReportPhotoPositionGroup;
